// components/Pagination.js
import React from "react";
import { ArrowLongLeftIcon, ArrowLongRightIcon } from "@heroicons/react/20/solid";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  if (!totalPages || totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const canGoPrev = currentPage > 1;
  const canGoNext = currentPage < totalPages;

  const handlePageClick = (page) => {
    if (page === currentPage) return;
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  return (
    <nav className="mt-4 flex items-center justify-between border-t border-gray-200 px-4 sm:px-0 dark:border-white/10">
      {/* Previous */}
      <div className="-mt-px flex w-0 flex-1">
        <button
          type="button"
          onClick={() => canGoPrev && handlePageClick(currentPage - 1)}
          disabled={!canGoPrev}
          className={`inline-flex items-center border-t-2 pt-4 pr-1 text-sm font-medium ${
            canGoPrev
              ? "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:border-white/20 dark:hover:text-gray-200"
              : "border-transparent text-gray-300 cursor-not-allowed dark:text-gray-600"
          }`}
        >
          <ArrowLongLeftIcon
            aria-hidden="true"
            className="mr-3 size-5 text-gray-400 dark:text-gray-500"
          />
          Précédent
        </button>
      </div>

      {/* Pages */}
      <div className="hidden md:-mt-px md:flex">
        {pages.map((page) => {
          const isCurrent = page === currentPage;
          return (
            <button
              key={page}
              type="button"
              onClick={() => handlePageClick(page)}
              aria-current={isCurrent ? "page" : undefined}
              className={
                "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium " +
                (isCurrent
                  ? "border-indigo-500 text-indigo-600 dark:border-indigo-400 dark:text-indigo-400"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:border-white/20 dark:hover:text-gray-200")
              }
            >
              {page}
            </button>
          );
        })}
      </div>

      {/* Next */}
      <div className="-mt-px flex w-0 flex-1 justify-end">
        <button
          type="button"
          onClick={() => canGoNext && handlePageClick(currentPage + 1)}
          disabled={!canGoNext}
          className={`inline-flex items-center border-t-2 pt-4 pl-1 text-sm font-medium ${
            canGoNext
              ? "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:border-white/20 dark:hover:text-gray-200"
              : "border-transparent text-gray-300 cursor-not-allowed dark:text-gray-600"
          }`}
        >
          Suivant
          <ArrowLongRightIcon
            aria-hidden="true"
            className="ml-3 size-5 text-gray-400 dark:text-gray-500"
          />
        </button>
      </div>
    </nav>
  );
}